import React, {useState} from 'react';
import './AlertaFixo.scss'

export default function AlertaFixo() {

  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
  };

  return (
    <>
      {isVisible ? (
        <div className="p-component alerta-fixo" onClick={handleClose}>
          Atenção! Contribuições salvas não são editáveis. <b style={{fontSize: '20px'}}>&times;</b>
        </div>
      ) : (
        <div className="p-component alerta-fixo" style={{visibility: 'hidden'}}>
        </div>
      )}
    </>
  );
};
